<template>
  <div class="fb fb-col font-34 bt bg-F6F6F6 tag-filter">
    <div class="item-flex-1 bg-FFFFFF p-0-16 mt-12 pb-72">
      <template v-if="tagList.length">
        <div v-for="(item, index) in tagList" :key="`tag${index}`">
          <h3 class="font-30 text-bold c-171A1D lh-48 bt"
            >选择{{ item.tagName }}</h3
          >
          <div class="fb fb-row fb-wrap">
            <div
              class="font-26 mr-8 mb-12 tag-list"
              v-for="(itm, idx) in item.tagOptionList"
              :key="`option${idx}`"
            >
              <div
                class="fb fb-cross-center fb-main-center p-0-8 text-center tag-item"
                :class="{
                  selected: selectedTags[item.tagId] === itm.tagOptionId
                }"
                @click="handleFilter(item, itm)"
                >{{ itm.tagOptionName }}</div
              >
            </div>
          </div>
        </div>
      </template>
      <div class="c-171A1D-40 font-28 pt-200 text-center" v-else>暂无标签</div>
    </div>
    <div class="footer fb fb-main-center fb-cross-center">
      <md-button @click="handleReset" type="submary" class="mr-16"
        >重置</md-button
      >
      <md-button @click="handleConfirm">确定</md-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import {} from '@/utils/constUtils'
import { combiTag, getLocalItem, getItem, deepCopy } from '@/utils/comUtils'
export default {
  name: 'commonTagFilter',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    campusId: {
      type: String,
      default: ''
    },
    addressType: {
      type: Number,
      default: 1 // 通讯录业务类型： 默认1 宿管通讯录2
    },
    initTags: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedTags: deepCopy(this.initTags), // 选中
      tagList: []
    }
  },
  computed: {
    commonParams() {
      return {
        campusId: this.campusId,
        operUserRoleTypes: getLocalItem(
          `CURRENT_ROLE_${getItem('TOKEN').orgId}`
        )
      }
    }
  },
  watch: {
    show(v) {
      if (v) {
        if (Object.keys(this.initTags).length) {
          this.selectedTags = deepCopy(this.initTags)
        } else {
          this.handleReset()
        }
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async init() {
      try {
        let res =
          (await API.apiGetTags({
            ...this.commonParams
          })) || []
        if (this.addressType === 2) {
          res = res.filter(item => {
            if (item.tagType === 2) {
              item.tagOptionList = item.tagOptionList.filter(opt =>
                ['住宿', '半住宿'].includes(opt.tagOptionName)
              )
            }
            return item.tagType === 2
          })
        }
        this.tagList = combiTag(res).map(item => {
          this.$set(this.selectedTags, item.tagId, '')
          return {
            ...item,
            tagOptionList: [
              {
                tagId: item.item,
                tagName: item.tagName,
                tagType: item.tagType,
                tagOptionId: '',
                tagOptionName: '全部'
              },
              ...item.tagOptionList,
              {
                tagId: item.item,
                tagName: item.tagName,
                tagType: item.tagType,
                tagOptionId: 0,
                tagOptionName: '无标签'
              }
            ]
          }
        })
      } catch (error) {}
    },
    handleReset() {
      Object.keys(this.selectedTags).forEach(item => {
        this.$set(this.selectedTags, item, '')
      })
    },
    // 选择标签
    handleFilter(item, itm) {
      this.$set(this.selectedTags, item.tagId, itm.tagOptionId)
    },
    handleConfirm() {
      this.$emit('confirm', this.selectedTags)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.tag-filter {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.tag-list {
  .tag-item {
    width: 109px;
    height: 45px;
    background: #f6f6f6;
    border-radius: 3px;
    border: 0.5px solid #f6f6f6;
    &.selected {
      width: 109px;
      height: 45px;
      background: rgba(0, 106, 254, 0.12);
      color: #006afe;
      border-color: #006afe;
      border-radius: 3px;
    }
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
}
</style>
